import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linkedin-container',
  templateUrl: './linkedin-container.component.html',
  styleUrls: ['./linkedin-container.component.scss']
})
export class LinkedinContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
